module.exports = __webpack_public_path__ + "static/media/drink.88c34d8d.jpg";